module.exports = __webpack_public_path__ + "img/MEDIA085.a631b56d.jpg";